import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.NuclearDensityGauge`]: 'Nuclear Density Gauge',
      [`${prefix}.Preparation.NuclearDensityGaugeSerialNumber`]: 'Nuclear Density Gauge Serial Number',
      [`${prefix}.Preparation.NuclearDensityGaugeMakeAndModel`]: 'Nuclear Density Gauge Make/Model',
      [`${prefix}.Preparation.TestNumber`]: 'Test Number',
      [`${prefix}.Preparation.DensityStandardCount`]: 'Density Standard Count',
      [`${prefix}.Preparation.MoistureStandardCount`]: 'Moisture Standard Count',

      [`${prefix}.ReferenceDensity.ImportedTest`]: 'Import Proctor from Sample',

      [`${prefix}.Measurements.Depth`]: 'Probe Depth',
      [`${prefix}.Measurements.NuclearDensityGaugeMode`]: 'Nuclear Density Gauge Mode',

      [`${prefix}.Results.MaximumDryDensity`]: 'Maximum Dry Density',
      [`${prefix}.Results.OptimumMoistureContent`]: 'Optimum Moisture Content',
      [`${prefix}.Results.RelativeCompaction`]: 'Relative Compaction',
      [`${prefix}.Results.MoistureVariation`]: 'Moisture Variation',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.OptimumMoistureContent`]: '%',
      [`${prefix}.Results.RelativeCompaction`]: '%',
      [`${prefix}.Results.MoistureVariation`]: '% from Optimum',
    })
  );

export default getLabelConfig;
